import { z } from 'zod';

import { uuidValidator } from '../../validators';

const BaseLearningTopicSchema = z.object({
  id: uuidValidator,
  name_de: z.string(),
  name_en: z.string(),
  name_ru: z.string(),
});

type IBaseLearningTopic = z.infer<typeof BaseLearningTopicSchema>;

export type ILearningTopicDto = IBaseLearningTopic & {
  subtopics?: ILearningTopicDto[];
};

export const LearningTopicSchema: z.ZodType<ILearningTopicDto> =
  BaseLearningTopicSchema.extend({
    subtopics: z.lazy(() => LearningTopicSchema.array()).optional(),
  });
